import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { BaseMessage } from "./BaseMessage.js";
import { useFieldContext } from "./FieldContext.js";
const ValidationMessage = /*#__PURE__*/ forwardRef(({ status: statusProperty, ...props }, ref)=>{
    const fieldContext = useFieldContext();
    const status = statusProperty ?? fieldContext?.status;
    return /*#__PURE__*/ jsx(BaseMessage, {
        status: status,
        testId: "validation-message",
        ...props,
        ref: ref
    });
});
ValidationMessage.displayName = 'ValidationMessage';
export { ValidationMessage };
